
define('text!platform/features/notebook/res/templates/annotation.html',[],function () { return '<div class="snap-annotation" id="snap-annotation" ng-controller="ngModel.controller">\n</div>';});

